import React, { useState } from 'react'
import { Form, InputGroup, Button } from 'react-bootstrap'

const PasswordInput = ({
  id,
  label = 'Password',
  value,
  onChange,
  placeholder = 'Enter password',
  disabled = false,
  errorText = '',
  autoComplete = 'current-password', // or 'new-password' for creation/reset
  onFocus,
  onBlur,
  name,
  inputRef,
  groupClassName = 'mb-3',
}) => {
  const [show, setShow] = useState(false)
  const toggle = () => setShow(s => !s)
  const icon = show ? 'fa-eye-slash' : 'fa-eye'
  const aria = show ? 'Hide password' : 'Show password'

  return (
    <Form.Group controlId={id} className={groupClassName}>
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Form.Control
          type={show ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoComplete={autoComplete}
          onFocus={onFocus}
          onBlur={onBlur}
          name={name}
          ref={inputRef}
        />
        <Button
          variant="outline-secondary"
          onClick={toggle}
          aria-label={aria}
          aria-pressed={show}
          title={aria}
          tabIndex={0}
          disabled={disabled}
        >
          <i className={`fas ${icon}`} />
        </Button>
      </InputGroup>
      {errorText && <small className='text-danger d-block'>{errorText}</small>}
    </Form.Group>
  )
}

export default PasswordInput
